/** @jsx isolateComponent */
import { Styles } from './Styles';
import { isolateComponent } from '@zapier/style-encapsulation';

export const SymbolSize20 = () => {
  return (
    <svg
      css={Styles.root}
      width="20"
      height="20"
      data-testid="ZapierLogoSymbolSmall"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="3" fill="#FF4F00" />
    </svg>
  );
};
